/* ===========================================================
   Jetter Pro Supply — Shopify theme behavior
   Ported from ref/assets/jps.js (chrome/drawer/menu/toast)
   Cart is wired to Shopify AJAX Cart API:
     POST /cart/add.js, GET /cart.js, POST /cart/change.js
   =========================================================== */
(function(){
  "use strict";

  var FREE_SHIP = 19900; // cents — free shipping threshold ($199)

  /* ---- money + stars helpers (kept on window for snippets) ---- */
  function JPS_money(cents){
    cents = parseInt(cents, 10) || 0;
    var fmt = window.JPS_MONEY_FORMAT || "${{amount}}";
    var amount = cents / 100;
    // Support Shopify money_format placeholders.
    function withComma(n, dec){
      return n.toLocaleString("en-US", {minimumFractionDigits:dec, maximumFractionDigits:dec});
    }
    function noComma(n, dec){
      return n.toFixed(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, name){
      switch(name){
        case "amount":                 return withComma(amount, 2);
        case "amount_no_decimals":     return withComma(Math.round(amount), 0);
        case "amount_with_comma_separator":     return amount.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});
        case "amount_no_decimals_with_comma_separator": return Math.round(amount).toLocaleString("de-DE");
        case "amount_with_space_separator":     return withComma(amount,2).replace(/,/g," ");
        default:                       return noComma(amount, 2);
      }
    });
  }
  window.JPS_money = JPS_money;

  function JPS_stars(r){
    r = parseFloat(r) || 0;
    var full = Math.floor(r), half = (r % 1) >= 0.5;
    return "★".repeat(full) + (half ? "½" : "") + "☆".repeat(Math.max(0, 5 - full - (half ? 1 : 0)));
  }
  window.JPS_stars = JPS_stars;

  /* ===========================================================
     TOAST
     =========================================================== */
  var toastTimer;
  function showToast(msg){
    var t = document.getElementById("toast"), m = document.getElementById("toastMsg");
    if(!t) return;
    if(m) m.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove("show"); }, 2400);
  }
  window.JPS_toast = showToast;

  /* ===========================================================
     DRAWER open/close
     =========================================================== */
  function openDrawer(){
    var d = document.getElementById("cartDrawer"), o = document.getElementById("drawerOverlay");
    if(d){ d.classList.add("open"); if(o) o.classList.add("open"); }
  }
  function closeDrawer(){
    var d = document.getElementById("cartDrawer"), o = document.getElementById("drawerOverlay");
    if(d){ d.classList.remove("open"); if(o) o.classList.remove("open"); }
  }
  window.JPS_openDrawer = openDrawer;
  window.JPS_closeDrawer = closeDrawer;

  /* ===========================================================
     SHOPIFY CART (AJAX)
     =========================================================== */
  var cartState = { items: [], item_count: 0, total_price: 0 };

  /* JPS_LOADOUT_OFFER_START
     The existing monthly drawing remains separate from the retired case offer. */
  var LOADOUT_ELIGIBLE = ["1-2-victory-line-cleaning-nozzle","1-2-victory-line-rotor-nozzle","1-2-victory-line-traction-nozzle-with-forward","aqua-power-mini-1-2","ball-nozzle-forward-jet-three-eighths","ball-nozzle-three-eighths","ball-nozzle-w-forward-jet-1-2","cleaning-nozzle-half-inch","cleaning-nozzle-three-eighths","duce-nozzle-1-2","duce-nozzle-three-eighths","egg-devastator-nozzle-1-2","egg-devastator-nozzle-three-eighths","egg-nozzle-1-2","egg-nozzle-forward-jet-three-eighths","forward-jet-nozzle-1-2","hand-injector-nozzle-1-2","quattro-hydro-excavating-nozzle-half-inch","quattro-nozzle-drill-point-half-inch","quattro-nozzle-drill-point-three-eighths","quattro-nozzle-forward-jets-half-inch","quattro-nozzle-forward-jets-three-eighths","rambo-nozzle-half-inch","rambo-nozzle-three-eighths","rotor-nozzle-45-degree-half-inch","rotor-nozzle-90-degree-half-inch","rotor-nozzle-three-eighths","sewer-flush-nozzle-1-2","sewer-flush-nozzle-3-8","sewer-flush-nozzle-three-eighths","standard-nozzle-forward-jet-three-eighths","standard-nozzle-half-inch","traction-nozzle-forward-jet-half-inch","traction-nozzle-forward-jet-three-eighths","twister-nozzle-1-2","victory-line-egg-w-forward-jet-1-2","victory-line-poking-nozzle-egg-devastator-1-2","victory-line-quattro-w-forward-chisel-1-2","victory-line-rambo-nozzle-1-2"];
  function loadoutNozzleCount(cart){
    return (cart.items || []).reduce(function(total,line){
      return total + (LOADOUT_ELIGIBLE.indexOf(line.handle) >= 0 ? line.quantity : 0);
    },0);
  }
  function loadoutOfferHtml(cart){
    var count=loadoutNozzleCount(cart), copy;
    if(count>=4)copy="Complete this order to receive entry in this month’s $100 JPS credit drawing. ";
    else copy="A purchase of four eligible nozzles includes entry in this month’s $100 JPS credit drawing. ";
    copy += '<a href="/pages/monthly-loadout-drawing" style="font-weight:800;color:#0b5794">No purchase necessary—free entry and rules.</a>';
    return '<div class="jps-loadout-offer" style="margin:12px 0;padding:12px;border:1px solid #b9d5ec;border-radius:8px;background:#edf7ff;color:#153a5a;font-size:13px;line-height:1.4"><b>Build your truck loadout</b><br>'+copy+'</div>';
  }
  /* JPS_LOADOUT_OFFER_END */

  function cartText(key,fallback){return (window.JPS_TEXT && window.JPS_TEXT[key]) || fallback;}
  function cartNotice(message){
    ["cartStatus","pageCartStatus"].forEach(function(id){
      var status=document.getElementById(id);
      if(status){status.hidden=!message;status.textContent=message||"";
        if(message){var link=document.createElement("a");link.href="/cart";link.textContent=cartText("cart_view","Review cart");status.appendChild(document.createTextNode(" "));status.appendChild(link);}
      }
    });
    if(message)showToast(message);
  }
  function readCartResponse(r){
    return r.json().then(function(data){
      if(!r.ok || !data || !Array.isArray(data.items) || !Number.isFinite(data.item_count) || !Number.isFinite(data.total_price)){
        var error=new Error(data && (data.description || data.message) || cartText("cart_rejected","Shopify could not update that quantity."));
        error.rejected=!r.ok&&[400,401,403,404,405,410,422].indexOf(r.status)>=0;throw error;
      }
      return data;
    });
  }
  function commitCart(cart){cartState=cart;renderCart(cart);document.dispatchEvent(new CustomEvent("jps:cart:updated",{detail:cart}));publishTransactionState();return cart;}
  function fetchCart(){
    return fetch("/cart.js", {cache:"no-store",headers:{"Accept":"application/json"}}).then(readCartResponse).then(commitCart);
  }
  window.JPS_refreshCart = function(){return queueCartOperation("refresh",fetchCart);};

  var transactionTail=Promise.resolve(), transactionPending=0, transactionUncertain=false, checkoutQueued=false, checkoutCommitted=false;
  function transactionState(){return {busy:transactionPending>0||checkoutQueued||checkoutCommitted,pending:transactionPending,uncertain:transactionUncertain,checkoutPending:checkoutQueued||checkoutCommitted};}
  function transactionError(code,message,uncertain){var error=new Error(message);error.code=code;error.uncertain=!!uncertain;return error;}
  function transactionCopy(key,fallback){return (window.JPS_CART_TEXT&&window.JPS_CART_TEXT[key])||fallback;}
  function lockedError(){return transactionError(transactionUncertain?"uncertain":"checkout_pending",transactionCopy("locked","Review and refresh your cart before making another change."),transactionUncertain);}
  function publishTransactionState(){
    var state=transactionState();
    document.querySelectorAll("[data-inc],[data-dec],[data-rm]").forEach(function(button){button.disabled=state.busy||state.uncertain;});
    document.dispatchEvent(new CustomEvent("jps:cart:transaction",{detail:state}));
  }
  function queueCartOperation(kind,task){
    if(transactionUncertain||checkoutCommitted||(checkoutQueued&&kind!=="checkout"))return Promise.reject(lockedError());
    transactionPending++;publishTransactionState();
    var operation=transactionTail.catch(function(){}).then(function(){
      if(transactionUncertain||checkoutCommitted)throw lockedError();
      return task();
    });
    transactionTail=operation.catch(function(){});
    return operation.finally(function(){transactionPending--;publishTransactionState();});
  }
  function normalizedProperties(properties){
    var result=Object.create(null);
    Object.keys(properties||{}).sort().forEach(function(key){
      var value=properties[key];
      if(value!=null&&String(value)!=="")result[key]=String(value);
    });
    return result;
  }
  function sameProperties(left,right){return JSON.stringify(normalizedProperties(left))===JSON.stringify(normalizedProperties(right));}
  function sameVariant(line,other){
    var leftPlan=line.selling_plan_allocation&&line.selling_plan_allocation.selling_plan;
    var rightPlan=other.selling_plan_allocation&&other.selling_plan_allocation.selling_plan;
    return String(line.variant_id||line.id)===String(other.variant_id||other.id)&&String(leftPlan&&leftPlan.id||"")===String(rightPlan&&rightPlan.id||"");
  }
  function sameIdentity(line,other){return sameVariant(line,other)&&sameProperties(line.properties,other.properties);}
  function cartFingerprint(cart){
    if(!cart||!Array.isArray(cart.items))return null;
    return JSON.stringify(cart.items.map(function(line){return [line.key,String(line.variant_id||line.id),line.quantity,normalizedProperties(line.properties),line.final_line_price];}).sort(function(a,b){return String(a[0]).localeCompare(String(b[0]));}));
  }
  function readFreshCart(){return fetch("/cart.js",{cache:"no-store",headers:{Accept:"application/json"}}).then(readCartResponse);}
  function requireLine(cart,key,expected){
    var line=cart.items.find(function(item){return item.key===key;});
    var stale=!line;
    if(line&&expected)stale=String(line.variant_id||line.id)!==String(expected.variant_id)||line.quantity!==Number(expected.quantity)||!sameProperties(line.properties,expected.properties);
    if(stale)throw transactionError("stale_line",transactionCopy("stale","This item changed. Refresh the cart and review its current setup before saving."));
    return line;
  }
  function lockUncertain(){transactionUncertain=true;publishTransactionState();}
  async function writeAndVerify(change,before,verify){
    try{
      var response=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(change)});
      await readCartResponse(response);
      var current=await readFreshCart();
      if(!verify(current))throw transactionError("verification_failed",transactionCopy("uncertain","We could not confirm this cart change. Review and refresh your cart before continuing."),true);
      return commitCart(current);
    }catch(error){
      var reconciled=await readFreshCart().catch(function(){return null;});
      if(reconciled)commitCart(reconciled);
      if(error.rejected&&cartFingerprint(reconciled)===cartFingerprint(before)){
        cartNotice(error.message);throw transactionError("rejected",error.message);
      }
      lockUncertain();
      var message=transactionCopy("uncertain","We could not confirm this cart change. Review and refresh your cart before continuing.");
      cartNotice(message);throw transactionError("uncertain",message,true);
    }
  }
  function updateProperties(request){
    if(!request||typeof request.key!=="string"||!request.expected||!request.expected.variant_id||!Number.isSafeInteger(Number(request.expected.quantity))||Number(request.expected.quantity)<1||!request.changes||typeof request.changes!=="object"||Array.isArray(request.changes))return Promise.reject(transactionError("invalid_request",transactionCopy("invalid","The cart change could not be prepared. Refresh the cart and try again.")));
    var key=request.key,expected={variant_id:String(request.expected.variant_id),quantity:Number(request.expected.quantity),properties:normalizedProperties(request.expected.properties)},changes=Object.create(null);
    try{Object.keys(request.changes).forEach(function(name){var value=request.changes[name];if(value!==null&&typeof value!=="string"&&typeof value!=="number"&&typeof value!=="boolean")throw Error("invalid");changes[name]=value===null?null:String(value);});}
    catch(error){return Promise.reject(transactionError("invalid_request",transactionCopy("invalid","The cart change could not be prepared. Refresh the cart and try again.")));}
    return queueCartOperation("properties",async function(){
      var before=await readFreshCart(),line=requireLine(before,key,expected),properties=normalizedProperties(line.properties);
      Object.keys(changes).forEach(function(name){if(changes[name]===null||changes[name]==="")delete properties[name];else properties[name]=changes[name];});
      if(sameProperties(line.properties,properties))return commitCart(before);
      if(!Object.keys(properties).length)throw transactionError("empty_properties",transactionCopy("empty_properties","At least one item detail must remain. Contact JPS if you need to clear every detail."));
      var proposed={variant_id:line.variant_id||line.id,properties:properties,selling_plan_allocation:line.selling_plan_allocation};
      if(before.items.some(function(other){return other.key!==key&&sameIdentity(other,proposed);}))throw transactionError("merge_required",transactionCopy("merge","This setup matches another cart line. Review both lines before combining them."));
      return writeAndVerify({id:key,quantity:line.quantity,properties:properties},before,function(after){
        var matches=after.items.filter(function(item){return sameIdentity(item,proposed);});
        return matches.length===1&&matches[0].quantity===line.quantity&&after.items.length===before.items.length&&before.items.filter(function(item){return item.key!==key;}).every(function(other){var remaining=after.items.find(function(item){return item.key===other.key;});return remaining&&sameIdentity(remaining,other)&&remaining.quantity===other.quantity;});
      });
    });
  }
  function hasUnsavedSetup(){return !!(window.JPSCartEditor&&typeof window.JPSCartEditor.hasUnsaved==="function"&&window.JPSCartEditor.hasUnsaved());}
  function checkoutTransaction(callback){
    if(typeof callback!=="function")return Promise.reject(transactionError("invalid_request",transactionCopy("invalid","The cart change could not be prepared. Refresh the cart and try again.")));
    if(hasUnsavedSetup())return Promise.reject(transactionError("unsaved_setup",transactionCopy("unsaved","Save or cancel your setup edits before continuing.")));
    if(transactionUncertain||checkoutQueued||checkoutCommitted)return Promise.reject(lockedError());
    checkoutQueued=true;publishTransactionState();
    return queueCartOperation("checkout",async function(){
      if(hasUnsavedSetup())throw transactionError("unsaved_setup",transactionCopy("unsaved","Save or cancel your setup edits before continuing."));
      var cart=await readFreshCart();commitCart(cart);
      if(hasUnsavedSetup())throw transactionError("unsaved_setup",transactionCopy("unsaved","Save or cancel your setup edits before continuing."));
      var continuing=await callback(cart);
      checkoutCommitted=continuing===true;
      return continuing;
    }).finally(function(){checkoutQueued=false;publishTransactionState();});
  }
  window.JPSCartTransactions={updateProperties:updateProperties,checkout:checkoutTransaction,isBusy:function(){return transactionState().busy;},state:transactionState};
  window.addEventListener("pageshow",function(event){
    if(!event.persisted||!checkoutCommitted||transactionUncertain)return;
    checkoutCommitted=false;checkoutQueued=false;
    window.JPS_refreshCart().catch(function(){cartNotice(cartText("cart_refresh_error","Could not refresh your cart. Review your cart before checkout."));});
  });

  function confirmsItems(cart,items){
    return !!cart && items.length>0 && items.every(function(item){
      var count=cart.items.reduce(function(total,line){
        if(String(line.variant_id || line.id)!==String(item.id))return total;
        var properties=item.properties||{},actual=line.properties||{};
        var expectedKeys=Object.keys(properties).filter(function(key){return properties[key]!=null && String(properties[key])!=="";}).sort();
        var actualKeys=Object.keys(actual).filter(function(key){return actual[key]!=null && String(actual[key])!=="";}).sort();
        if(JSON.stringify(expectedKeys)!==JSON.stringify(actualKeys) || !expectedKeys.every(function(key){return String(actual[key])===String(properties[key]);}))return total;
        return total+(Number.isFinite(line.quantity)?line.quantity:0);
      },0);
      return count>=Number(item.quantity);
    });
  }
  function confirmsReceipt(added,items){
    var lines=added && (Array.isArray(added.items)?added.items:[added]);
    return !!lines && items.length>0 && items.every(function(item){return lines.some(function(line){return String(line.variant_id || line.id)===String(item.id);});});
  }
  var addBusy=false, uncertainVariants={};
  function performAddNow(body,headers,items){
    items=items||[];
    if(addBusy)return Promise.resolve({status:"rejected",reason:"busy"});
    if(items.some(function(item){return uncertainVariants[String(item.id)];})){cartNotice(cartText("cart_locked","Review your cart before adding this item again."));openDrawer();return Promise.resolve({status:"uncertain",accepted:false});}
    addBusy=true;
    var tracking=window.JPSConversionEvents, attempt=tracking&&tracking.cartAttempt?tracking.cartAttempt(items):null;
    var accepted=false, rejected=false, serverMessage="",addedResponse=null;
    return fetch("/cart/add.js",{method:"POST",headers:headers,body:body}).then(function(r){
      if(r.ok){accepted=true;return r.json().catch(function(){return {};}).then(function(data){addedResponse=data;return data;});}
      if(r.status>=400 && r.status<500 && r.status!==422)rejected=true;
      return r.json().catch(function(){return {};}).then(function(data){serverMessage=data.description || data.message || "";throw new Error(serverMessage || cartText("cart_add_rejected","This item could not be added."));});
    }).then(function(){
      return fetchCart().then(function(cart){if(!confirmsReceipt(addedResponse,items) || !confirmsItems(cart,items))throw new Error("unreconciled");cartNotice("");showToast(cartText("cart_added","Added to cart."));openDrawer();return {status:"added"};});
    }).catch(function(err){
      if(rejected){cartNotice(err.message);return {status:"rejected"};}
      var message=cartText(accepted?"cart_added_unconfirmed":"cart_uncertain",accepted?"Shopify accepted your item. Review your cart before adding again.":"We could not confirm whether your item was added. Review your cart before trying again.");
      return fetchCart().catch(function(){return null;}).then(function(cart){
        if(accepted && confirmsReceipt(addedResponse,items) && confirmsItems(cart,items)){cartNotice("");showToast(cartText("cart_added","Added to cart."));openDrawer();return {status:"added"};}
        cartNotice((serverMessage?serverMessage+" ":"")+message);openDrawer();return {status:"uncertain",accepted:accepted};
      });
    }).then(function(result){
      addBusy=false;
      if(result.status==="uncertain")items.forEach(function(item){uncertainVariants[String(item.id)]=true;});
      if(tracking&&tracking.cartResult)tracking.cartResult(attempt,result,addedResponse);
      return result;
    },function(error){
      addBusy=false;items.forEach(function(item){uncertainVariants[String(item.id)]=true;});
      var result={status:"uncertain",accepted:accepted};
      if(tracking&&tracking.cartResult)tracking.cartResult(attempt,result,addedResponse);
      return result;
    });
  }
  var addQueued=false;
  function performAdd(body,headers,items){
    if(addQueued||addBusy)return Promise.resolve({status:"rejected",reason:"busy"});
    addQueued=true;
    return queueCartOperation("add",function(){return performAddNow(body,headers,items).then(function(result){
      if(result.status==="uncertain")lockUncertain();
      return result;
    });}).catch(function(error){cartNotice(error.message);return {status:error.uncertain?"uncertain":"rejected",reason:error.code||"cart_unavailable"};}).finally(function(){addQueued=false;});
  }
  window.JPS_addItems=function(items){return performAdd(JSON.stringify({items:items}),{"Content-Type":"application/json","Accept":"application/json"},items);};
  function addToCart(variantId, qty, properties){
    var item={id:variantId,quantity:parseInt(qty,10)||1};
    if(properties && Object.keys(properties).length)item.properties=properties;
    return window.JPS_addItems([item]);
  }
  window.JPS_addToCart = addToCart;

  function changeLine(key, qty){
    if(!Number.isSafeInteger(qty)||qty<0)return Promise.reject(transactionError("invalid_quantity",transactionCopy("quantity_invalid","Enter a whole quantity of zero or more.")));
    if(hasUnsavedSetup()){var dirtyError=transactionError("unsaved_setup",transactionCopy("unsaved","Save or cancel your setup edits before continuing."));cartNotice(dirtyError.message);return Promise.reject(dirtyError);}
    var cached=findLine(key),expected=cached?{variant_id:cached.variant_id||cached.id,quantity:cached.quantity,properties:normalizedProperties(cached.properties)}:null;
    return queueCartOperation("quantity",async function(){
      if(hasUnsavedSetup())throw transactionError("unsaved_setup",transactionCopy("unsaved","Save or cancel your setup edits before continuing."));
      var before=await readFreshCart(),line=requireLine(before,key,expected);
      if(hasUnsavedSetup())throw transactionError("unsaved_setup",transactionCopy("unsaved","Save or cancel your setup edits before continuing."));
      if(line.quantity===qty)return commitCart(before);
      var equivalent=before.items.filter(function(other){return sameIdentity(other,line);});
      if(equivalent.length!==1)throw transactionError("ambiguous_line",transactionCopy("stale","This item changed. Refresh the cart and review its current setup before saving."));
      return writeAndVerify({id:key,quantity:qty},before,function(after){
        var matching=after.items.filter(function(item){return sameIdentity(item,line);});
        var total=matching.reduce(function(sum,item){return sum+item.quantity;},0);
        return total===qty&&before.items.filter(function(item){return item.key!==key;}).every(function(other){return after.items.some(function(item){return sameIdentity(item,other)&&item.quantity===other.quantity;});});
      });
    }).then(function(cart){cartNotice("");return cart;}).catch(function(error){cartNotice(error.message);throw error;});
  }
  window.JPS_changeLine = changeLine;

  function renderCart(cart){
    cart = cart || cartState;

    /* header count badges */
    document.querySelectorAll("[data-cart-count]").forEach(function(el){
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "" : el.style.display;
    });

    var items = document.getElementById("drawerItems");
    var foot  = document.getElementById("drawerFoot");
    if(!items) return;

    if(!cart.items || cart.items.length === 0){
      items.innerHTML = '<div class="dempty"><svg viewBox="0 0 24 24" stroke-width="1.6"><circle cx="9" cy="21" r="1.4"/><circle cx="18" cy="21" r="1.4"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6" stroke-linecap="round" stroke-linejoin="round"/></svg><p>Your cart is empty.</p></div>';
      if(foot) foot.style.display = "none";
      return;
    }
    if(foot) foot.style.display = "block";

    items.innerHTML = cart.items.map(function(l){
      var img = l.image
        ? '<div class="dthumb"><img src="'+l.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, "_120x$1")+'" alt="'+escapeHtml(l.product_title)+'" style="width:100%;height:100%;object-fit:contain;background:#fff;"></div>'
        : '<div class="dthumb ph"><span class="tag">img</span></div>';
      var propsHtml = "";
      if(l.properties){
        var pk = Object.keys(l.properties).filter(function(k){ return k.charAt(0) !== "_" && (l.properties[k]+"").trim(); });
        if(pk.length){
          propsHtml = '<div class="dprops">' + pk.map(function(k){
            return '<span><b>'+escapeHtml(k)+':</b> '+escapeHtml(l.properties[k])+'</span>';
          }).join("") + '</div>';
        }
      }
      return '<div class="ditem" data-key="'+l.key+'">'+
        img +
        '<div class="dinfo">'+
          '<div class="dname"><a href="'+l.url+'">'+escapeHtml(l.product_title)+'</a></div>'+
          (l.variant_title&&l.variant_title!=="Default Title"?'<div class="dvariant">'+escapeHtml(l.variant_title)+'</div>':"")+
          '<div class="dprice">'+JPS_money(l.final_price)+'</div>'+
          propsHtml +
          '<a class="dsetup" href="/cart#cart-line-'+encodeURIComponent(l.key)+'" style="display:inline-flex;align-items:center;min-height:44px;">'+escapeHtml(transactionCopy("edit_setup","Review or edit setup"))+'</a>'+
          '<div class="qty"><button type="button" style="min-width:44px;min-height:44px;" aria-label="'+escapeHtml(transactionCopy("decrease","Decrease quantity")+' — '+l.product_title)+'" data-dec="'+l.key+'">−</button><span aria-label="'+escapeHtml(transactionCopy("quantity","Quantity"))+'">'+l.quantity+'</span><button type="button" style="min-width:44px;min-height:44px;" aria-label="'+escapeHtml(transactionCopy("increase","Increase quantity")+' — '+l.product_title)+'" data-inc="'+l.key+'">+</button></div>'+
          '<button type="button" class="dremove" style="min-height:44px;" aria-label="'+escapeHtml(transactionCopy("remove","Remove")+' — '+l.product_title)+'" data-rm="'+l.key+'">'+escapeHtml(transactionCopy("remove","Remove"))+'</button>'+
        '</div></div>';
    }).join("");
    items.insertAdjacentHTML("beforeend", loadoutOfferHtml(cart));

    var sub = cart.total_price;
    var subEl = document.getElementById("drawerSubtotal");
    if(subEl) subEl.textContent = JPS_money(sub);

    var remain = Math.max(0, FREE_SHIP - sub);
    var bar = document.getElementById("shipBar");
    var msg = document.getElementById("shipMsg");
    if(bar) bar.style.width = Math.min(100, (sub / FREE_SHIP) * 100) + "%";
    if(msg && window.JPS_SHIPPING_COPY) msg.textContent = remain > 0
      ? window.JPS_SHIPPING_COPY.remaining.replace('__AMOUNT__', JPS_money(remain))
      : window.JPS_SHIPPING_COPY.reached;

    /* wire qty + remove */
    items.querySelectorAll("[data-inc]").forEach(function(b){
      b.onclick = function(){ var l = findLine(b.dataset.inc); if(l) changeLine(b.dataset.inc, l.quantity + 1).catch(function(){}); };
    });
    items.querySelectorAll("[data-dec]").forEach(function(b){
      b.onclick = function(){ var l = findLine(b.dataset.dec); if(l) changeLine(b.dataset.dec, l.quantity - 1).catch(function(){}); };
    });
    items.querySelectorAll("[data-rm]").forEach(function(b){
      b.onclick = function(){ changeLine(b.dataset.rm, 0).catch(function(){}); };
    });
  }
  window.JPS_renderCart = renderCart;

  function findLine(key){
    for(var i=0;i<cartState.items.length;i++){ if(cartState.items[i].key === key) return cartState.items[i]; }
    return null;
  }
  function escapeHtml(s){
    return String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
  }

  /* ===========================================================
     SEARCH suggestions (lightweight — submit goes to /search)
     =========================================================== */
  function wireSearch(){
    document.querySelectorAll(".search-form").forEach(function(form){
      var box = form.querySelector(".suggest");
      if(box){
        var input = form.querySelector("input[name='q']") || form.querySelector("input");
        document.addEventListener("click", function(e){ if(!form.contains(e.target)) box.classList.remove("open"); });
      }
      /* let native GET submit to /search?q= */
    });
  }

  /* ===========================================================
     MEGA MENU ("Shop By Category")
     =========================================================== */
  function wireMega(){
    var btn = document.getElementById("shopcatBtn"),
        mega = document.getElementById("mega"),
        ov  = document.getElementById("megaOverlay");
    if(!btn || !mega) return;
    function toggle(open){
      btn.classList.toggle("open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      mega.classList.toggle("open", open);
      if(ov) ov.classList.toggle("open", open);
    }
    btn.addEventListener("click", function(e){ e.stopPropagation(); toggle(!mega.classList.contains("open")); });
    if(ov) ov.addEventListener("click", function(){ toggle(false); });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") toggle(false); });
  }

  /* ===========================================================
     MOBILE NAV
     =========================================================== */
  function wireMobile(){
    var open  = document.getElementById("hamburger"),
        nav   = document.getElementById("mnav"),
        ov    = document.getElementById("mnavOverlay"),
        close = document.getElementById("mnavClose");
    if(!open || !nav) return;
    function set(o){
      nav.classList.toggle("open", o);
      if(ov) ov.classList.toggle("open", o);
      document.body.style.overflow = o ? "hidden" : "";
    }
    open.addEventListener("click", function(){ set(true); });
    if(close) close.addEventListener("click", function(){ set(false); });
    if(ov) ov.addEventListener("click", function(){ set(false); });
  }

  /* ===========================================================
     ADD-TO-CART intercept (buttons + forms)
     =========================================================== */
  /* Read the optional "Tell us about your jetter" fields on the product page.
     Returns line-item properties (visible on the Shopify order) so JPS can
     confirm/recommend the right nozzle. Skips empty fields. */
  function collectJetterProps(){
    var map = [
      ["jsGpm",     "Jetter Flow (GPM)"],
      ["jsPsi",     "Jetter Pressure (PSI)"],
      ["jsHose",    "Hose ID"],
      ["jsConnection", "Hose Connection"],
      ["jpsFinderContext", "Finder Context"],
      ["jpsRangeReview", "Setup check"],
      ["jsLength",  "Hose Length (ft)"],
      ["jsApp",     "Application"],
      ["jsMachine", "Machine Make/Model"],
      ["jsNotes",   "Pipe Size / Notes"]
    ];
    var props = {};
    for(var i=0;i<map.length;i++){
      var el = document.getElementById(map[i][0]);
      if(el && !el.disabled){
        var v = (el.value || "").trim();
        if(v){ props[map[i][1]] = v; }
      }
    }
    return props;
  }

  /* Match compound inch sizes before their fractional component. */
  function normHose(s){
    s = (s || "").toString();
    if(/1[-\s]+1\/4|1\s*¼|1\.25/.test(s)) return '1-1/4"';
    if(s.indexOf("1/4") >= 0) return '1/4"';
    if(s.indexOf("3/8") >= 0) return '3/8"';
    if(s.indexOf("1/2") >= 0) return '1/2"';
    if(s.indexOf("5/8") >= 0) return '5/8"';
    if(s.indexOf("3/4") >= 0) return '3/4"';
    if(/(^|[^\d/])1"?($|[^\d/])/.test(s) || s.trim() === '1"' || s.trim() === '1') return '1"';
    return "";
  }
  /* Map a hose token to the matching per-size collection so we can send the customer to the right kits */
  function hoseCollection(tok){
    var m = { '1/4"':"1-4-inch-jetter-nozzles", '3/8"':"3-8-inch-jetter-nozzles", '1/2"':"1-2-inch-jetter-nozzles", '3/4"':"3-4-inch-jetter-nozzles", '1"':"1-inch-jetter-nozzles", '1-1/4"':"1-1-4-inch-jetter-nozzles" };
    return m[tok] || null;
  }

  /* Require rated machine flow for nozzle and nozzle-kit purchases, then run
     the existing hose-fit guard when the customer provides hose details. */
  function validateJetterFit(b){
    var fit = document.getElementById("jsFit");
    var gpmEl = document.getElementById("jsGpm");
    var hoseEl = document.getElementById("jsConnection");
    var lenEl  = document.getElementById("jsLength");
    var requiresGpm = b.getAttribute("data-requires-gpm") === "1";
    if(!gpmEl && !hoseEl && !lenEl){ return { ok:true }; } /* form not present */

    /* clear prior error styling */
    document.querySelectorAll(".js-grid label.js-err").forEach(function(l){ l.classList.remove("js-err"); });

    var rawGpm = gpmEl ? (gpmEl.value || "").trim() : "";
    var gpm = Number(rawGpm);
    var kegFlows = (b.getAttribute("data-keg-flow-options") || "").split(",").filter(Boolean).map(Number);
    if(rawGpm && kegFlows.length && kegFlows.indexOf(gpm) < 0){
      openForm();
      if(gpmEl){ gpmEl.closest("label").classList.add("js-err"); try { gpmEl.focus(); } catch(e){} }
      return {ok:false,block:true,html:b.getAttribute("data-keg-flow-message")};
    }
    var hose = hoseEl ? (hoseEl.value || "").trim() : "";
    var len  = lenEl ? (lenEl.value || "").trim() : "";

    function openForm(){ var s = document.getElementById("jetterSetup"); if(s) s.open = true; }

    if(requiresGpm && (!rawGpm || !Number.isFinite(gpm) || gpm <= 0 || gpm > 200)){
      openForm();
      if(gpmEl){ gpmEl.closest("label").classList.add("js-err"); try { gpmEl.focus(); } catch(e){} }
      return { ok:false, block:true,
        html: '<b>Enter your jetter’s rated GPM before adding this item.</b> Use the flow shown on the pump or machine plate. We attach it to the order so JPS can verify the nozzle configuration before shipment.' };
    }

    var psiEl = document.getElementById("jsPsi");
    var requiresPsi = b.getAttribute("data-requires-psi") === "1";
    var rawPsi = psiEl ? psiEl.value.trim() : "";
    if(requiresPsi && (!rawPsi || !Number.isInteger(Number(rawPsi)) || Number(rawPsi)<=0)){
      openForm();
      if(psiEl){psiEl.closest("label").classList.add("js-err");psiEl.focus();}
      return {ok:false,block:true,html:'<b>Enter the working PSI you plan to run before adding this item.</b> Your GPM and PSI stay with the order for the final configuration check.'};
    }
    if(!requiresPsi && rawPsi && (!Number.isInteger(Number(rawPsi)) || Number(rawPsi)<=0)){
      openForm();
      if(psiEl){psiEl.closest("label").classList.add("js-err");psiEl.focus();}
      return {ok:false,block:true,html:'<b>Check the PSI you entered.</b> Use a whole number, or leave it blank and JPS will confirm it with you.'};
    }
    var pressureLimit = psiEl ? Number(psiEl.getAttribute("max")) : 0;
    if(rawPsi && pressureLimit > 0 && Number(rawPsi) > pressureLimit){
      openForm();
      psiEl.closest("label").classList.add("js-err");psiEl.focus();
      return {ok:false,block:true,html:escapeHtml(psiEl.getAttribute("data-limit-message"))};
    }
    var variantSelect = document.getElementById("variantSel");
    var selected = variantSelect && variantSelect.options[variantSelect.selectedIndex];
    var namedFlow = selected && selected.textContent.match(/(?:^|[^\d.])(\d+(?:\.\d+)?)\s*GPM/i);
    if(!requiresGpm && rawGpm && (!Number.isFinite(gpm) || gpm <= 0 || gpm > 200)){
      openForm();
      if(gpmEl){ gpmEl.closest("label").classList.add("js-err"); try { gpmEl.focus(); } catch(e){} }
      return { ok:false, block:true, html:'<b>Check the GPM you entered.</b> Use the flow on your pump or machine plate, or leave it blank and JPS will confirm it with you.' };
    }
    if((requiresGpm || rawGpm) && namedFlow && (b.dataset.reviewProduct === "true" ? Number(namedFlow[1]) !== gpm : Math.abs(Number(namedFlow[1])-gpm)>0.01)){
      openForm();
      return {ok:false,block:true,html:'<b>Your entered GPM differs from the selected nozzle configuration.</b> Select the matching GPM option or contact JPS for the correct setup before adding.'};
    }
    /* End connection is checked separately from hose inside diameter. */
    if(!hose){ return { ok:true }; }

    /* mismatch guard: customer hose vs. product hose */
    var prodTok = normHose(b.getAttribute("data-hose"));
    var custTok = normHose(hose);
    var notSure = /not\s*sure/i.test(hose);

    if(prodTok && custTok && prodTok !== custTok){
      openForm();
      var optional = document.getElementById("jetterOptionalDetails"); if(optional) optional.open = true;
      if(hoseEl) hoseEl.closest("label").classList.add("js-err");
      var coll = hoseCollection(custTok);
      var cta = coll
        ? '<a class="js-fit-cta" href="/collections/' + coll + '">Shop ' + custTok + ' nozzles &amp; kits →</a>'
        : '<a class="js-fit-cta" href="tel:8648046637">Call (864) 804-6637 for the right fit</a>';
      return { ok:false, block:true, warn:false, allowOverride:true,
        html: 'This is a <b>' + prodTok + '</b> setup, but your hose end connection is <b>' + custTok + '</b>. '
            + 'A ' + prodTok + ' nozzle will <b>not</b> thread onto a ' + custTok + ' line — you’d get the wrong kit. '
            + 'Get the one built for your hose:<br>' + cta
            + '<button type="button" class="js-fit-anyway" id="jsAddAnyway">Add anyway — I know my fit</button>' };
    }

    if(notSure){
      openForm();
      return { ok:false, block:false, warn:true,
        html: 'Confirm your hose connection, inside diameter, length, GPM and PSI with JPS. '
            + '<a href="/pages/nozzle-guide">Find it in 30 seconds →</a> or call <a href="tel:8648046637">(864) 804-6637</a>. '
            + 'You can still add to cart — we double-check fit before every order ships.' };
    }

    return { ok:true };
  }

  function showFit(res){
    var fit = document.getElementById("jsFit");
    if(!fit) return;
    if(!res || res.ok){ fit.hidden = true; fit.className = "js-fit"; fit.innerHTML = ""; return; }
    fit.hidden = false;
    fit.className = "js-fit " + (res.block ? "is-block" : "is-warn");
    fit.innerHTML = res.html;
    if(res.allowOverride){
      var anyway = fit.querySelector("#jsAddAnyway");
      if(anyway){
        anyway.addEventListener("click", function(){
          window.__jpsFitOverride = true;
          var addBtn = document.getElementById("pdpAdd");
          if(addBtn){ addBtn.click(); }
        });
      }
    }
    try { fit.scrollIntoView({ behavior:"smooth", block:"center" }); } catch(e){}
  }

  function wireAddToCart(){
    /* clear fit message as the customer corrects the fields */
    ["jsGpm","jsPsi","jsConnection","jsHose","jsLength","variantSel"].forEach(function(id){
      var e = document.getElementById(id);
      if(e) e.addEventListener("change", function(){ showFit({ ok:true }); });
    });

    /* delegate [data-add="<variantId>"] buttons anywhere */
    document.body.addEventListener("click", function(e){
      var b = e.target.closest("[data-add]");
      if(b){
        e.preventDefault();
        var vid = b.getAttribute("data-add");
        if(!vid) return;
        if(b.disabled || b.dataset.cartPending === "true" || b.dataset.cartUncertain === "true")return;
        if(b.dataset.reviewProduct === "true"){
          var reviewedSelect=document.getElementById("variantSel");
          if(b.dataset.variantAvailable !== "true" || (reviewedSelect && reviewedSelect.dataset.explicitConfiguration === "true" && !reviewedSelect.value))return;
        }
        var consent=document.getElementById('jsBackorderConsent');
        if(b.getAttribute('data-backorder')==='1' && (!consent || !consent.checked)){
          if(consent){consent.reportValidity();consent.focus();consent.scrollIntoView({block:'center'});}
          return;
        }
        /* PDP jetter add: enforce hose fit before anything hits the cart */
        var isJetter = (b.getAttribute("data-jetter") === "1");
        if(isJetter){
          if(window.__jpsFitOverride){
            /* customer explicitly chose "Add anyway" on a size mismatch */
            window.__jpsFitOverride = false;
            showFit({ ok:true });
          } else {
            var res = validateJetterFit(b);
            if(!res.ok){ showFit(res); if(res.block){ return; } }
            else { showFit({ ok:true }); }
          }
        }
        var qty = parseInt(b.getAttribute("data-qty") || "1", 10);
        /* if a qty input is associated via data-qty-source, read it */
        var src = b.getAttribute("data-qty-source");
        if(src){ var qi = document.querySelector(src); if(qi) qty = parseInt(qi.value, 10) || 1; }
        /* collect jetter setup line-item properties if this is the PDP add button */
        var props = isJetter ? collectJetterProps() : null;
        /* GPM is optional on non-Direct Hit nozzles: flag the line so JPS calls before shipping */
        if(isJetter && b.getAttribute("data-setup-optional") === "1" && props && !props["Jetter Flow (GPM)"]){
          props["Setup check"] = "GPM not given. JPS to call customer before shipping";
          if(b.dataset.reviewProduct === "true"){props["_jps_setup_review"] = "required";}
        }
        if(b.getAttribute('data-backorder')==='1'){
          props=props||{};
          props['Availability']='Backorder — ship date not yet confirmed';
          props['Backorder acknowledgement']='Accepted: awaiting shipment from Australia; no confirmed ship date';
        }
        if(b.getAttribute('data-team-configured')==='1'){
          props=props||{};
          props['Configuration']='Complete nozzle/head as described; JPS to confirm assembly and machine fit before shipment';
          props['_jps_configuration_review']='required';
        }
        b.disabled = true;
        b.dataset.lastAddStatus = "";
        b.dataset.cartPending = "true";
        document.dispatchEvent(new Event("jps:purchase-state"));
        addToCart(vid, qty, props).then(function(result){
          b.dataset.lastAddStatus = result && result.status || "rejected";
          b.dataset.cartPending = "false";
          b.dataset.cartUncertain = result && result.status === "uncertain" ? "true" : "false";
          b.disabled = b.dataset.cartUncertain === "true" || b.dataset.variantAvailable === "false";
          document.dispatchEvent(new Event("jps:purchase-state"));
        });
      }
    });

    /* intercept standard product add-to-cart forms (action contains /cart/add) */
    document.body.addEventListener("submit", function(e){
      var form = e.target.closest('form[action*="/cart/add"]');
      if(!form) return;
      e.preventDefault();
      if(form.dataset.cartPending === "true" || form.dataset.cartUncertain === "true")return;
      var fd = new FormData(form), formId=fd.get("id"), formQty=parseInt(fd.get("quantity"),10)||1, formProps={};
      fd.forEach(function(value,key){var match=/^properties\[(.+)\]$/.exec(key);if(match && typeof value==="string")formProps[match[1]]=value;});
      form.dataset.cartPending="true";
      var buttons=Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
      buttons.forEach(function(button){button.disabled=true;});
      performAdd(fd,{"Accept":"application/json"},formId?[{id:formId,quantity:formQty,properties:formProps}]:[]).then(function(result){
        form.dataset.cartPending="false";
        form.dataset.cartUncertain=result.status==="uncertain"?"true":"false";
        buttons.forEach(function(button){button.disabled=result.status==="uncertain";});
        document.dispatchEvent(new Event("jps:purchase-state"));
      });
    });
  }

  /* ===========================================================
     INIT
     =========================================================== */
  document.addEventListener("DOMContentLoaded", function(){
    wireSearch(); wireMega(); wireMobile(); wireAddToCart();

    /* open cart drawer triggers */
    document.querySelectorAll("[data-open-cart]").forEach(function(b){
      b.addEventListener("click", function(e){ e.preventDefault(); openDrawer(); });
    });
    var dc = document.getElementById("drawerClose");   if(dc) dc.addEventListener("click", closeDrawer);
    var dov = document.getElementById("drawerOverlay"); if(dov) dov.addEventListener("click", closeDrawer);
    var cs = document.getElementById("continueShop");  if(cs) cs.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeDrawer(); });

    /* initial cart hydrate */
    window.JPS_refreshCart().catch(function(){cartNotice(cartText("cart_refresh_error","Could not refresh your cart. Review your cart before checkout."));});
  });
})();

